
// import React from "react";

// interface Props {
//   label: string;
//   value: string;
//   onChange: (value: string) => void;
// }

// const TextInput: React.FC<Props> = ({ label, value, onChange }) => {
//   return (
//     <div className="mb-3">
//       <label className="block text-sm font-semibold" htmlFor={label}>{label}</label>
//       <input
//         type="text"
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         className="w-full p-2 border rounded"
//         id={label}
//         aria-label={label}
//       />
//     </div>
//   );
// };

// export default TextInput;


import React from "react";

interface TextInputProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  className?: string; // Accept className as an optional prop
  placeholder?: string;
}

const NgwTextInput: React.FC<TextInputProps> = ({ label, value, onChange, className, placeholder }) => {
  return (
    <div className={`mb-4 ${className || ""}`}> {/* Apply className if provided */}
      <label className="text-sm font-semibold block mb-1">{label}</label>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="border rounded-md p-2 w-full"
        id={label}
        aria-label={label}
      />
    </div>
  );
};

export default NgwTextInput;

